import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel1 = null;
        this.ctner1 = this.element.querySelector('.js-swiper1');
        this.carousel2 = null;
        this.ctner2 = this.element.querySelector('.js-swiper2');




        let config = {
            slidesPerView: "auto",
            initialSlide: 2,
            spaceBetween: 16,
            centeredSlides: true,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: false,
            },
            watchOverflow: true,
            observer: true
        };
        this.initCarousel(config);
    }
    disconnect() {
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Navigation, Pagination}) => {
                Swiper.use([FreeMode, Navigation, Pagination]);

                this.carousel1 = new Swiper(this.ctner1, config);
                this.carousel2 = new Swiper(this.ctner2, config);
            });
        });
    }
}